import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import * as Ant from "antd";
import { Routes } from "@bundles/UIAppBundle";
import { useUIComponents, useRouter, useDataOne, use, useTranslate, } from "@bluelibs/x-ui";
import { ObjectId } from "@bluelibs/ejson";
import { TransactionsCollection, } from "@bundles/UIAppBundle/collections";
import { TransactionViewer } from "../../config/TransactionViewer";
import { features } from "../../config/features";
const renderNestedObject = (obj) => {
    if (obj) {
        return (_jsx("div", Object.assign({ className: "transaction-view-initial-data-container" }, { children: Object.keys(obj).map((key, keyIndex) => {
                if (typeof obj[key] === "string") {
                    return (_jsxs("div", { children: [_jsx("p", Object.assign({ className: "transaction-view-initial-data-bold" }, { children: key }), void 0), _jsx("p", { children: obj[key] }, void 0)] }, keyIndex));
                }
                else if (typeof obj[key] === "number") {
                    return (_jsxs("div", { children: [_jsx("p", Object.assign({ className: "transaction-view-initial-data-bold" }, { children: key }), void 0), _jsx("p", { children: obj[key] }, void 0)] }, keyIndex));
                }
                else if (typeof obj[key] === "object") {
                    if (Array.isArray(obj[key])) {
                        return (_jsxs("div", { children: [_jsx("p", Object.assign({ className: "transaction-view-initial-data-bold" }, { children: key }), void 0), _jsx(Ant.Col, { children: obj[key].map((arrVal, index) => (_jsx("p", { children: arrVal }, index))) }, void 0)] }, void 0));
                    }
                    else {
                        return renderNestedObject(obj[key]);
                    }
                }
            }) }), void 0));
    }
    else {
        return undefined;
    }
};
export function TransactionsView(props) {
    var _a, _b, _c, _d, _e, _f;
    const UIComponents = useUIComponents();
    const router = useRouter();
    const t = useTranslate();
    const collection = use(TransactionsCollection);
    // If you want to benefit of live data features use useLiveData()
    const { data: document, isLoading, error, } = useDataOne(TransactionsCollection, new ObjectId(props.id), TransactionViewer.getRequestBody());
    let content;
    if (isLoading) {
        content = (_jsx(Ant.Space, Object.assign({ align: "center" }, { children: _jsx(Ant.Spin, { size: "large" }, void 0) }), void 0));
    }
    else {
        if (error || document === null) {
            content = (_jsx(Ant.Alert, { message: error.message || t("generics.error_message"), type: "error" }, void 0));
        }
        else {
            content = _jsx(TransactionsViewComponent, { document: document }, void 0);
        }
    }
    return (_jsx(UIComponents.AdminLayout, { children: _jsxs("div", Object.assign({ className: "bg-white" }, { children: [_jsx(Ant.PageHeader, { title: t("management.transactions.view.header"), onBack: () => window.history.back(), extra: getHeaderActions(collection, router, props.id) }, void 0), _jsx(Ant.Card, { children: content }, void 0), _jsx(Ant.Card, Object.assign({ title: t("management.transactions.fields.initialDatasHeader"), className: "transaction-view-mt" }, { children: _jsxs(Ant.Row, Object.assign({ gutter: 15 }, { children: [_jsxs(Ant.Col, Object.assign({ span: 24, md: 12 }, { children: [_jsx("h2", { children: t("management.transactions.fields.sourceBankAccount") }, void 0), renderNestedObject((_b = (_a = document === null || document === void 0 ? void 0 : document.initialDatas) === null || _a === void 0 ? void 0 : _a.bankAccounts) === null || _b === void 0 ? void 0 : _b.sourceBankAccount)] }), void 0), _jsxs(Ant.Col, Object.assign({ span: 24, md: 12 }, { children: [_jsx("h2", { children: t("management.transactions.fields.destinationBankAccount") }, void 0), renderNestedObject((_d = (_c = document === null || document === void 0 ? void 0 : document.initialDatas) === null || _c === void 0 ? void 0 : _c.bankAccounts) === null || _d === void 0 ? void 0 : _d.destinationBankAccount)] }), void 0), _jsxs(Ant.Col, Object.assign({ span: 24, md: 12 }, { children: [_jsx("h2", { children: t("management.transactions.fields.company") }, void 0), renderNestedObject((_e = document === null || document === void 0 ? void 0 : document.initialDatas) === null || _e === void 0 ? void 0 : _e.company)] }), void 0), _jsxs(Ant.Col, Object.assign({ span: 24, md: 12 }, { children: [_jsx("h2", { children: t("management.transactions.fields.external") }, void 0), renderNestedObject((_f = document === null || document === void 0 ? void 0 : document.initialDatas) === null || _f === void 0 ? void 0 : _f.external)] }), void 0)] }), void 0) }), void 0)] }), void 0) }, void 0));
}
export function TransactionsViewComponent(props) {
    const document = props.document;
    const viewer = use(TransactionViewer, { transient: true });
    viewer.setDocument(document);
    viewer.build();
    return (_jsx(Ant.Descriptions, Object.assign({ column: { xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 3 } }, { children: viewer.rest().map((item) => {
            return (_jsx(Ant.Descriptions.Item, Object.assign({ label: item.label }, { children: viewer.render(item) }), item.id));
        }) }), void 0));
}
export function getHeaderActions(collection, router, id) {
    const actions = [];
    const t = useTranslate();
    if (features.edit) {
        actions.push(_jsx(Link, Object.assign({ to: router.path(Routes.TRANSACTIONS_EDIT, {
                params: { id },
            }) }, { children: _jsx(Ant.Button, { children: t("generics.edit") }, void 0) }), "edit"));
    }
    if (features.delete) {
        actions.push(_jsx(Ant.Popconfirm, Object.assign({ title: t("management.transactions.delete_question"), onConfirm: () => {
                collection.deleteOne(id).then(() => {
                    router.go(Routes.TRANSACTIONS_LIST);
                    Ant.notification.success({
                        message: t("generics.success"),
                        description: t("management.transactions.delete_confirmation"),
                    });
                });
            } }, { children: _jsx(Ant.Button, Object.assign({ className: "ant-btn-danger" }, { children: t("generics.delete") }), void 0) }), "delete"));
    }
    const viewRoutePath = router.path(Routes.TRANSACTIONS_VIEW, {
        params: { id },
    });
    return actions;
}
